import { useForm } from "@mantine/form";
import React, {
    useState
} from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import useApi from "../../services/useApi";
import { SearchFilters } from "src/model/SearchFilters";
import SimpleSearch from "./SimpleSearch";

export default function AdvancedSearch(props: {
  onSubmit(searchFilters: SearchFilters): void;
}) {
  const dispatch = useAppDispatch();
  const locationState = useAppSelector((state) => state.location);

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { createLocation, updateLocation, fetchLocations, loading } = useApi();
  const profileState = useAppSelector((state) => state.profile);

  const form = useForm({
    mode: "controlled",
    initialValues: {
      name: selectedLocation?.name ?? "",
    },

    validate: (values) => {
      return {
        name:
          values.name.trim().length < 2
            ? "Name must include at least 2 characters"
            : null,
      };
    },
  });

  return <div className="flex flex-col w-full h-full">
    Advanced Search
  </div>;
}
